import { axios, AxiosResponse } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";

import type {
  SetAccountingFlagRequest,
  SetAccountingFlagResult,
} from "./accounting-flags-models";

export class AccountingFlagsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.accountingFlags.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.accountingFlags = {
      configure: (cfg: { basePath?: string; token?: string }) => {
        Object.assign(this.config, cfg);
      },
      set: async (
        body: SetAccountingFlagRequest
      ): Promise<SetAccountingFlagResult> => {
        const response: AxiosResponse<SetAccountingFlagResult> = await axios.post(
          `${this.config.basePath}/accounting/flags`,
          body,
          { headers: { Authorization: this.config.token } }
        );
        return response.data;
      },
    };
    this.accountingFlags.configure(config);
  }

  accountingFlags!: {
    configure: (config: { basePath?: string; token?: string }) => void;
    set: (body: SetAccountingFlagRequest) => Promise<SetAccountingFlagResult>;
  };
}

export const accountingFlagsServices = new AccountingFlagsServices(SDKConfig);
